import { Pipe, PipeTransform } from '@angular/core';
import { diffInYearsFromNow } from '@libs/utils';

@Pipe({
  name: 'age',
  pure: true,
  standalone: true,
})
export class AgePipe implements PipeTransform {
  public transform(value: Date | string): number {
    return diffInYearsFromNow(new Date(value));
  }
}
